import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import './CaseDetailsPersonCard.scss';
import constants from "../../../constants";
import IntitialsIcon from '../../Common/InitialsIcon';

export default function PersonCard(props) {
  const { name, role, displayName, organization, imageURL } = props;

  return (
    <div className="person-card">
      <Row>
        <Col id="person-image-icon" sm={2} lg={2}>{imageURL ? <img id="person-image" src={imageURL} alt="User Icon" /> : <IntitialsIcon name={name}/>}</Col>
        <Col sm={10} lg={9} className="person-info">
          <div id="person-info-head">
            <h4 className="person-name">{name}</h4>
          </div>
          {role === constants.faRole ?
            <p id="person-role">{organization ? `${displayName} - ${organization}` : displayName}</p> :
            <p id="person-role">{organization ? `${role} - ${organization}` : role}</p>
          }
        </Col>
      </Row>
    </div>
  )
}

PersonCard.propTypes = {
  name: PropTypes.string.isRequired,
  role: PropTypes.string.isRequired,
  organization: PropTypes.string,
  imageURL: PropTypes.string,
}





// WEBPACK FOOTER //
// ./src/components/ActivityCenter/SubComponents/CaseDetailsPersonCard.js